<app-shipment-system-simplenav></app-shipment-system-simplenav>

<div class="container">
    <div class="row">

        <div class="col-12">
            <h3>Info</h3>
            <ul>
                <li>
                    <a href="https://www.dropbox.com/c/scl/fi/hgn6ku18vn0kqd14kou3n/Bestillingsoversigt.paper?rlkey=araskqopk263lxtx0kotphd26&st=w0k71b10&dl=0"
                       target="_blank">Bestillingsoversigt</a>
                </li>
            </ul>
        </div>
        <div class="col-6">
            <h3>Status:</h3>
            <table>
                <tr *ngFor="let state of shipmentStates">
                    <td>
                        <app-shipment-status-widget [status]="state.key" [label]="state.name"
                                                    [showLabel]="true"></app-shipment-status-widget>
                    </td>
                </tr>
            </table>
        </div>
        <div class="col-6">
            <h3>IDA Lager status:</h3>
            <table>
                <tr *ngFor="let productLine of dummyProductLines">
                    <td>
                        <app-shipment-status-widget [color]="productLine.stockStatusColor()"
                                                    [label]="productLine.formattedStockStatus()"
                                                    [variant]="true"
                                                    [showLabel]="true"></app-shipment-status-widget>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
